import slice from "./subscriptionsSlice";

export default slice.reducer;
